import React from "react";

const STATUS_COLOR: Record<string, string> = {
  LAUNCHING: "#1890ff",
  RUNNING: "#1890ff",
  SCHEDULED: "#722ed1",
  SUCCESS: "#52c41a",
  ERROR: "#ff4d4f",
  CANCELLED: "#faad14",
  CANCEL_REQUESTED: "#faad14",
  DELETED: "#8c8c8c",
};

export const formatRoute = (
  route?: string | null,
  source?: string | null,
  destination?: string | null,
): string => {
  if (route?.trim()) return route.replace(/\s*->\s*/g, " → ");
  if (source || destination) {
    return `${source || "—"} → ${destination || "—"}`;
  }
  return "—";
};

export const formatTimestamp = (value?: string | null): string => {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  const iso = parsed.toISOString();
  return `${iso.slice(0, 16).replace("T", " ")} UTC`;
};

export const StatusDot: React.FC<{ status?: string }> = ({ status }) => (
  <span
    style={{
      display: "inline-block",
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: STATUS_COLOR[status?.toUpperCase() ?? ""] ?? "#8c8c8c",
      marginRight: 8,
      flexShrink: 0,
    }}
  />
);

export const StatusBadge: React.FC<{ status?: string }> = ({ status }) => (
  <span className="dt-status-badge">{status || "—"}</span>
);

export const RouteCell: React.FC<{
  route?: string | null;
  source?: string | null;
  destination?: string | null;
  status?: string;
}> = ({ route, source, destination, status }) => {
  const label = formatRoute(route, source, destination);
  return (
    <span className="dt-route-cell" title={label}>
      <StatusDot status={status} />
      <span className="dt-route-text">{label}</span>
    </span>
  );
};
